<template>
  <layout :title="pageTitle">
    <b-tabs>
      <b-field>
        <inertia-link :href="route('clients.create')" class="is-pulled-right">
          <b-button class="is-primary" size="is-small" icon-left="plus">
            Add Client
          </b-button>
        </inertia-link>
      </b-field>
      <b-tab-item label="Clients">
        <b-table :data="active">
          <b-table-column
            field="name"
            label="Name"
            v-slot="props"
            sortable
            :searchable="isSearchable"
          >
            {{ props.row.name }}
          </b-table-column>

          <b-table-column numeric label="Actions" v-slot="props">
            <inertia-link :href="route('clients.show', props.row.unique_id)">
              <b-button type="is-primary" size="is-small">Edit</b-button>
            </inertia-link>
          </b-table-column>
        </b-table>
      </b-tab-item>
      <b-tab-item label="Trashed">
        <b-table :data="trashed">
          <b-table-column
            field="name"
            label="Name"
            v-slot="props"
            sortable
            :searchable="isSearchable"
          >
            {{ props.row.name }}
          </b-table-column>

          <b-table-column numeric label="Actions" v-slot="props">
            <inertia-link
              method="patch"
              :href="route('clients.restore', props.row.unique_id)"
            >
              <b-button type="is-success" size="is-small">Restore</b-button>
            </inertia-link>
          </b-table-column>
        </b-table>
      </b-tab-item>
    </b-tabs>
  </layout>
</template>

<script>
import Layout from './Layout';

export default {
  components: {
    Layout,
  },
  props: {
    clients: Array,
  },
  data() {
    return {
      pageTitle: 'Manage Clients',
    };
  },
  computed: {
    isSearchable: function () {
      return this.clients.length > 10;
    },
    active() {
      return this.clients.filter((c) => c.deleted_at === null);
    },
    trashed() {
      return this.clients.filter((c) => c.deleted_at !== null);
    },
  },
};
</script>
